var React = require('react');

function Remove (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z","fill":"white","stroke":"#DDDDDD","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.91236 7.08752L7.0874 7.91248L10.1749 11L7.0874 14.0875L7.91236 14.9125L10.9999 11.825L14.0874 14.9125L14.9124 14.0875L11.8248 11L14.9124 7.91248L14.0874 7.08752L10.9999 10.175L7.91236 7.08752Z","fill":"#00121A","key":1})]);
}

Remove.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none"};

module.exports = Remove;

Remove.default = Remove;
